export class FlightUtil {

    static regExp5 = (/[0-9][0-9][0-9][0-9][A-Z]/);
    static regExp4 = (/[0-9][0-9][0-9][A-Z0-9]/);
    // static regExp3 = (/[0-9][0-9][0-9]/);
    static regExp3 = (/^(?!0+$)[0-9][0-9][0-9]/);

    public static getNumericOfFlightNumber(flightNumberString: string): number {
        if (Number.isNaN(+flightNumberString)) {
            // Desccomponemos el string
            const separateString = flightNumberString.split('', flightNumberString.length);
            let flightNumberAux = '';
            for (const character of separateString) {
                if (!Number.isNaN(+character)) {
                    flightNumberAux += character;
                } else {
                    return flightNumberAux.length > 0 ? Number(flightNumberAux) : -1;
                }

            }
            return Number(flightNumberAux);

        } else {
            return Number(flightNumberString);
        }
    }

    public static getCharacterOfFlightNumber(flightNumberString: string): string {
        if (Number.isNaN(+flightNumberString)) {
            // Desccomponemos el string
            const separateString = flightNumberString.split('', flightNumberString.length);
            const regExp = (/[A-Z]/);
            for (const character of separateString) {
                if (Number.isNaN(+character)) {
                    if (regExp.test(character.toUpperCase())) {
                        return character.toUpperCase();
                    }
                }
            }
            return null;
        } else {
            return null;
        }
    }

    public static getSecondPartOfFlightNumber(flightNumberString: string): string {
        if (Number.isNaN(+flightNumberString)) {
            // Desccomponemos el string
            const separateString = flightNumberString.split('', flightNumberString.length);
            const regExp = (/[A-Z]/);
            let index = 0;
            let secondParat = '';
            for (const character of separateString) {
                if (Number.isNaN(+character)) {
                    if (!secondParat && regExp.test(character.toUpperCase())) {
                        secondParat = flightNumberString.substring(index, flightNumberString.length);
                    }
                }
                index++;
            }
            if (secondParat) {
                return secondParat;
            }
            return null;
        } else {
            return null;
        }
    }

    public static getAllCharacterOfFlightNumber(flightNumberString: string): string {
        if (Number.isNaN(+flightNumberString)) {
            // Desccomponemos el string
            const separateString = flightNumberString.split('', flightNumberString.length);
            const regExp = (/[A-Z]/);
            let flightNumberAux = '';
            for (const character of separateString) {
                if (Number.isNaN(+character)) {
                    if (regExp.test(character.toUpperCase())) {
                        flightNumberAux += character.toUpperCase();
                    }
                }
            }
            return flightNumberAux.length > 0 ? flightNumberAux : null;
        } else {
            return null;
        }
    }

	public static flightNumberRectificate(flightNumber: string): string {
		if (flightNumber == null) {
			return null;
        }
        // const charNumber: string = FlightUtil.getCharacterOfFlightNumber(flightNumber);
        // const charactersNumber: string = FlightUtil.getAllCharacterOfFlightNumber(flightNumber);
        const secondaryPart: string = FlightUtil.getSecondPartOfFlightNumber(flightNumber);
		const numericString = this.getNumericOfFlightNumber(flightNumber);
		return `${FlightUtil.flightNumberRectificateNumberPart(numericString >= 0 ? numericString.toString() : '')}${secondaryPart ? secondaryPart : ''}`;
	}

	public static flightNumberRectificateNumberPart(flightNumber: string): string {
		if (flightNumber.length === 4) {
			return flightNumber;
		} else {
            flightNumber = flightNumber.padStart(3, '0');
            return flightNumber;
        }
	}

    public static isCorrectFormat(value: string): boolean {
        if (value.length === 5) {
          return FlightUtil.regExp5.test(value);
        } else if (value.length === 4) {
          return FlightUtil.regExp4.test(value);
        } else if (value.length === 3) {
            return FlightUtil.regExp3.test(value);
        } else {
          return false;
        }
    }

}
